import { FC, useState } from "react";
import { cn } from "@/libs/utils";
import { useTrans } from "src/utils/useTrans";
import CloseIcon from "@/v2-components/core/icon/close-icon";

type Props = {
  options: { id: string; label: string }[];
  selectedOption: string;
  onClose: (id: string) => void;
};

const SelectLegalTerm: FC<Props> = ({ selectedOption, options, onClose }) => {
  const { t } = useTrans(["gnb", "index"]);

  const [selected, setSelected] = useState(selectedOption);

  return (
    <div
      className={cn(
        "flex h-full w-full flex-col justify-end overflow-y-hidden text-[#212630]",
      )}
    >
      <div className={"flex h-15 self-end py-4 pr-3"}>
        <button
          className={"text-black active:opacity-75"}
          onClick={() => onClose(selectedOption)}
        >
          <CloseIcon className="size-6" />
        </button>
      </div>
      <div className={"flex-grow overflow-y-auto px-5"}>
        <div className={"mt-2.5"}>
          {options.map((option, index) => {
            const chosen = option.id === selected;

            return (
              <div
                onClick={() => {
                  setSelected(option.id);
                }}
                key={index}
                className={"flex flex-col"}
              >
                <div
                  className={cn(
                    chosen ? "opacity-100" : "opacity-60",
                    "flex h-15 cursor-pointer items-center justify-between active:opacity-80",
                  )}
                >
                  <span className={"text font-700 capitalize"}>
                    {t(`${option.label}`)}
                  </span>
                </div>
                <span
                  className={"inline-block h-px w-full bg-[#212630] opacity-10"}
                />
              </div>
            );
          })}
        </div>
      </div>
      <button
        onClick={() => {
          onClose(selected);
        }}
        className={"h-15 w-full bg-[#222222] text-[17px] font-700 text-white"}
      >
        {/* ⚠️ `ns` 필수 — `useTrans` 는 첫 namespace(gnb)에만 바인딩되고
            fallbackNS 가 없다. "DONE" 은 index.json 에만 있어서 ns 를 빼면
            7개 locale 전부 영어 "DONE" 으로 떨어진다. */}
        <span>{t("DONE", { ns: "index" })}</span>
      </button>
    </div>
  );
};

export default SelectLegalTerm;
